import React, { useCallback, useReducer } from 'react'

function useQueryReducer() {

    const initialState = {
        country: [],
        gender: [],
        source_type: [],
        languages: [],
        sentiment: [],
        date_range: []
    }

    const reducer = (state, action) => {
        return { ...state, ...action }
    }

    const [state, dispatch] = useReducer(reducer, initialState)

    const clearAllFilters = () => {
        dispatch(initialState)
    }

    return {
        state,
        dispatch,
        clearAllFilters
    }

}

export default useQueryReducer